// Sentry initialization should be imported first!
import "./configureSentry";
import "./configureMixpanel";

// Third party
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "vite/modulepreload-polyfill";

// Project imports
import App from "./App";

// Style + assets
import "./assets/scss/style.scss";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
